import type { SectionType } from "../lib/segment-types";

const base = {
  width: 16, height: 16, viewBox: "0 0 16 16", fill: "none",
  stroke: "currentColor", strokeWidth: 1.5,
  strokeLinecap: "round" as const, strokeLinejoin: "round" as const,
  "aria-hidden": true, focusable: false,
};

/** A tile that says what kind of section this is before any content loads. */
export function SectionIcon({ type, size = 16 }: { type: SectionType; size?: number }) {
  const glyph = () => {
    switch (type) {
      case "category":
        return <><path d="M3 3.5v9M3 8h6M9 3.5v9" /><path d="M12 7l1.5-1v6.5" /></>;
      case "featured":
        return <><rect x="2" y="2.5" width="12" height="6.5" rx="1.5" /><path d="M2.5 11.5h11M2.5 13.5h7" /></>;
      case "text":
        return <path d="M2.5 4h11M2.5 7h11M2.5 10h11M2.5 13h7" />;
      case "image":
        return <><rect x="2" y="3" width="12" height="10" rx="2" /><circle cx="6" cy="7" r="1.2" /><path d="M3 12l3.5-3.5L9 11l2-2 2 2" /></>;
      case "articles":
        return <><rect x="2" y="3" width="12" height="10" rx="2" /><path d="M5 6.5h6M5 9.5h4" /></>;
      case "block":
        // A picture beside two lines of copy — the block's default shape.
        return <><rect x="2" y="4" width="5.5" height="8" rx="1.2" /><path d="M9.5 6h4.5M9.5 9h4.5M9.5 11.5h3" /></>;
      case "banner":
        return <><rect x="2" y="4.5" width="12" height="7" rx="2" /><path d="M5 8h6" /></>;
      case "tip":
        return <><path d="M8 2.5a3.5 3.5 0 0 0-2 6.4V11h4V8.9a3.5 3.5 0 0 0-2-6.4Z" /><path d="M6.5 13h3" /></>;
      case "doctor":
        return <><circle cx="8" cy="5.5" r="2.4" /><path d="M3.5 13c.6-2.6 2.3-3.9 4.5-3.9s3.9 1.3 4.5 3.9" /></>;
      case "cta":
        return <><rect x="2" y="5" width="12" height="6" rx="3" /><path d="M6.5 8h3" /></>;
      case "footer":
        return <><rect x="2" y="3" width="12" height="10" rx="2" /><path d="M2 10.5h12M5 12.5h2" /></>;
      case "divider":
        return <path d="M2.5 8h11" />;
      case "spacer":
        return <><path d="M8 3v10" /><path d="M5.5 5.5 8 3l2.5 2.5M5.5 10.5 8 13l2.5-2.5" /></>;
      default:
        return <><path d="M3 4.5h10M3 8h10M3 11.5h6" /></>;
    }
  };
  // At tile size the 1.5 stroke on a 16 grid would read heavy; keep it near
  // the standard's 1.75px line whatever the rendered size.
  const stroke = size === 16 ? 1.5 : (1.75 * 16) / size;
  return (
    <span className="nl-sec-icon">
      <svg {...base} width={size} height={size} strokeWidth={stroke}>{glyph()}</svg>
    </span>
  );
}
